import { PropsWithChildren } from "react";
import { Box } from "@mui/material";

export type ItemContainerProps = PropsWithChildren<{}>;

export const ItemContainer = ({ children }: ItemContainerProps) => {
  return <Box sx={{ display: "flex", flexDirection: "column", rowGap: "5px", py: "10px" }}>{children}</Box>;
};
